import React from 'react';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import breakpoints from 'utils/breakpoints';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import cx from 'classnames';

const Title = styled.h1`
  letter-spacing: -0.5px;
  line-height: 2.625rem;

  @media ${breakpoints.md} {
    line-height: 4.375rem;
  }
`;
const Copy = styled.div`
  letter-spacing: 0.14px;
  line-height: 1.625rem;

  & ul {
    width: fit-content;
    list-style: disc;
    padding-left: 1.25rem;
    margin-left: 1.25rem;
  }

  & ol {
    width: fit-content;
    list-style: upper-greek;
    padding-left: 1.25rem;
    margin-left: 1.25rem;
  }
`;
const LargeTitleAndText = ({ title, text, textAlignment }) => (
  <div className='w-full'>
    <Title
      className={cx(
        'text-4xl md:text-6xl font-trade-gothic-20 text-mattamy-blue',
        {
          'text-center': textAlignment && textAlignment !== 'left',
          'text-left': !textAlignment || textAlignment === 'left',
        },
      )}
    >
      {title}
    </Title>
    <Copy
      className={cx(
        'mt-0 md:mt-2 text-xl leading-7 font-graphie text-mattamy-blue',
        {
          'text-center': textAlignment && textAlignment !== 'left',
          'text-left': !textAlignment || textAlignment === 'left',
        },
      )}
    >
      <RichText tag='span' className='richtext' field={{ value: text }} />
    </Copy>
  </div>
);

LargeTitleAndText.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
};

export default LargeTitleAndText;
